import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
declare var LOG_ROUTER: boolean;

/**
 * Allows override of Router methods to log debug live environments.
 * Enabling logging utilizes a global variable: LOG_ROUTER
 * <p>
 * In the browser console:
 * <code>
 *   LOG_ROUTER = true
 * </code>
 * </p>
 * The stack trace will be logged locally as well as to sentry for more indepth analysis/metrics.
 * @see Router
 */
@Injectable()
export class RouterLogger extends Router {
  override navigate(commands: any[], extras?: NavigationExtras) {
    try {
      // Logs the stack trace to find what guard or component called the navigate method
      if (LOG_ROUTER) console.log(new Error().stack);
    } catch (e) {}
    return super.navigate(commands, extras);
  }
}
